export default "__VITE_ASSET___EWNE9Bp__"